/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig, contentOnly} from "./helper";
import MasterDataCultivarResponse from "./MasterDataCultivarResponse";
import CultivarLinkCoverage from "./CultivarLinkCoverage";

const urls = {
    optionsForCrop(cropId: number): string {
        return queryUrl("/masterdatacultivar/optionsforcrop", {cropId});
    },
    linkedIds(cultivarId: number): string {
        return queryUrl("/masterdatacultivar/linkedids", {cultivarId});
    },
    coverage(): string {
        return "/masterdatacultivar/coverage";
    }
}

export default {
    urls,
    optionsForCrop(cropId: number): Promise<MasterDataCultivarResponse[]> {
        return contentOnly(Axios.get(queryUrl("/masterdatacultivar/optionsforcrop", {cropId}), defaultConfig));
    },
    linkedIds(cultivarId: number): Promise<number[]> {
        return contentOnly(Axios.get(queryUrl("/masterdatacultivar/linkedids", {cultivarId}), defaultConfig));
    },
    coverage(): Promise<CultivarLinkCoverage> {
        return contentOnly(Axios.get("/masterdatacultivar/coverage", defaultConfig));
    }
}
